import { render } from "./ItemListTutoria.vue?vue&type=template&id=2d6dd92a&scoped=true"
import script from "./ItemListTutoria.vue?vue&type=script&lang=js"
export * from "./ItemListTutoria.vue?vue&type=script&lang=js"

import "./ItemListTutoria.vue?vue&type=style&index=0&id=2d6dd92a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6dd92a"]])

export default __exports__